import Error from "./components/Error";
import Success from "./components/Success";

// Status screen for the root ErrorBoundary (401/404/409/429/500) and the payment result.
// Props: type "success" | "error" | undefined (warning), title, description, toDo + toDoHref (action), autoReloadAfter (ms), children.
function MessageCard(props) {
  return props.type === "success" ? <Success {...props} /> : <Error {...props} />;
}

export default MessageCard;
